import PropTypes from 'prop-types';
// @flow

import React, { Component } from 'react';
import I18n from 'PMT/i18n/I18n';

import Constants from 'constants/Constants';

// -- views
import Select from 'react-select';

class DayChooser extends Component {

  static propTypes = {
    day: PropTypes.number.isRequired,

    // param: number (Constants.Day)
    onChange: PropTypes.func.isRequired
  };

  shouldComponentUpdate(nextProps) {
    return this.props.day !== nextProps.day;
  }

  onChange = (option) => {
    this.props.onChange(option.value);
  };

  render() {
    const options = [
      {
        value: Constants.Day.MONDAY,
        label: I18n.tr('global.days.monday'),
      },
      {
        value: Constants.Day.TUESDAY,
        label: I18n.tr('global.days.tuesday'),
      },
      {
        value: Constants.Day.WEDNESDAY,
        label: I18n.tr('global.days.wednesday'),
      },
      {
        value: Constants.Day.THURSDAY,
        label: I18n.tr('global.days.thursday'),
      },
      {
        value: Constants.Day.FRIDAY,
        label: I18n.tr('global.days.friday'),
      },
      {
        value: Constants.Day.SATURDAY,
        label: I18n.tr('global.days.saturday'),
      },
      {
        value: Constants.Day.SUNDAY,
        label: I18n.tr('global.days.sunday'),
      },
    ];

    return (
      <div className="day_chooser">
        <Select
          name="day"
          value={this.props.day}
          options={options}
          onChange={this.onChange}
          clearable={false}
        />
      </div>
    );
  }

}

export default DayChooser;



// WEBPACK FOOTER //
// ./scripts/components/DayChooser.js